import { EducationalPathDTO } from '../../dto/educational-path/educational-path.dto';
import { EducationalPathItem } from './EducationalPathItem.model';
import { EducationalPathUserDTO } from '../../dto/educational-path/educational-path-user.dto';
import { EducationalPathVersion } from './EducationalPathVersion.model';

export class EducationalPath {
    constructor(
        public path_id: number | null,
        public base_path_id: number,
        public name: string | null,
        public full_name: string | null,
        public guid: string,
        public visibility: string | null,
        public organizations_id: number | null,
        public created_at: string | null,
        public updated_at: string | null,
        public deleted: boolean,
        public icon: string | null,
        public grace_period_days?: number | null,
        public maintenance_interval_days?: number | null,
        public maintenance: EducationalPathItem[] = [],
        public requirements: EducationalPathItem[] = [],
        public assigned_users: EducationalPathUserDTO[] = [],
        public assigned_users_count: number = 0,
        public versions: EducationalPathVersion[] = []
    ) {}

    static fromDTO(dto: EducationalPathDTO): EducationalPath {
        const path = new EducationalPath(
            dto.path_id,
            dto.base_path_id,
            dto.name,
            dto.full_name,
            dto.guid,
            dto.visibility,
            dto.organizations_id,
            dto.created_at,
            dto.updated_at,
            dto.deleted,
            dto.icon,
            undefined,
            undefined,
            [],
            [],
            dto.assigned_users,
            dto.assigned_users_count,
            dto.versions.map(v => EducationalPathVersion.fromDTO(v))
        );

        return path;
    }

    toDTO(): EducationalPathDTO {
        return {
            path_id: this.path_id,
            base_path_id: this.base_path_id,
            name: this.name,
            full_name: this.full_name,
            guid: this.guid,
            visibility: this.visibility,
            organizations_id: this.organizations_id,
            created_at: this.created_at,
            updated_at: this.updated_at,
            deleted: this.deleted,
            icon: this.icon,
            assigned_users: this.assigned_users,
            assigned_users_count: this.assigned_users_count,
            versions: this.versions.map(v => v.toDTO())
        };
    }
} 